import { jsx as r } from "react/jsx-runtime";
import { useRef as u, useEffect as b, useState as E, useLayoutEffect as W } from "react";
import S from "react-focus-lock";
import { RemoveScroll as g } from "react-remove-scroll";
import { Provider as w } from "../context.js";
import { DialogOverlay as k, StyledDialog as L, Content as R } from "../styles.js";
import { Portal as C } from "../../Portal/Portal.js";
const D = () => {
  const [l, t] = E(0);
  return W(() => {
    const e = document.createElement("div");
    e.style.visibility = "hidden", e.style.overflow = "scroll", document.body.appendChild(e);
    const o = document.createElement("div");
    e.appendChild(o), t(e.offsetWidth - o.offsetWidth), e?.parentNode?.removeChild(e);
  }, []), l;
}, F = ({
  children: l,
  opened: t,
  title: e,
  onClose: o,
  size: f = "default",
  overflow: m = "auto",
  inPortal: h = !0,
  className: v
}) => {
  const i = u(null), d = u(null);
  b(() => {
    const y = i.current, n = d.current;
    if (!t || !n || !y || n.open)
      return;
    const a = (s) => {
      !s.defaultPrevented && s.key === "Escape" && o();
    };
    return n.show(), document.addEventListener("keydown", a), () => {
      document.removeEventListener("keydown", a);
    };
  }, [t, o]);
  const p = D();
  if (!t) return null;
  const c = /* @__PURE__ */ r(S, { children: /* @__PURE__ */ r(g, { children: /* @__PURE__ */ r(k, { ref: i, children: /* @__PURE__ */ r(
    L,
    {
      ref: d,
      "aria-label": e ?? "Dialog",
      "aria-modal": "true",
      $size: f,
      $overflow: m,
      className: v,
      children: /* @__PURE__ */ r(w, { value: { onClose: o }, children: /* @__PURE__ */ r(R, { $scrollbarWidth: p, children: l }) })
    }
  ) }) }) });
  return h ? /* @__PURE__ */ r(C, { children: c }) : c;
};
export {
  F as ModalShell
};
//# sourceMappingURL=ModalShell.js.map
